// 组件全局注册
import Vue from 'vue'

import AppBorder from './AppBorder'
import AppNotes from './AppNotes'
import AppTitle from './AppTitle'
import AppToolbar from './AppToolbar'
import AppSection from './AppSection'
import AppSearch from './AppSearch'
import TableMixin from './TableMixin'
import ossUpload from './Upload'
import Nation from './Nation'
import bigImage from './Viewm/bigImage'
import smallImage from './Viewm/smallImage'
import Viewm from './Viewm/Viewm'
import ViewmUlti from './Viewm/ViewmUlti'

// 组件库
const Components = [
    AppBorder,
    AppNotes,
    AppTitle,
    AppToolbar,
    AppSection,
    AppSearch,
    TableMixin,
    ossUpload,
    Nation,
    bigImage,
    smallImage,
    Viewm,
    ViewmUlti
]

// 注册全局组件
Components.map((com) =>{
    Vue.component(com.name, com)
})

export default Vue


// WEBPACK FOOTER //
// ./src/components/install.js